import React, { Component } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
  ReferenceLine
} from 'recharts';
import { Input, Button } from 'reactstrap';
import * as Request from '../service/data-info-chart/requestsUtil';
import { NEW_BUSINESS_VISITS } from '../utils/constants';

class VisitsNewBusiness extends Component {
  constructor(props) {
    super(props);
    this.fetch = this.fetch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { data: [], name: '', appointments: '', graphHeight: 0 };
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  componentDidMount() {
    this.fetch('', '');
  }

  fetch(name, appointments) {
    Request.getFetch(NEW_BUSINESS_VISITS + '?name=' + name + '&appointmentCount=' + appointments)
      .then(resp => {
        let data = [];
        resp.map(arr => {
          data.push({
            name: arr.municipality + ' ' + arr.operationType,
            visitas: arr.appointments
          });
        });
        this.setState({ data: data, graphHeight: data.length*40 });
      });
  }


  render() {
    return (
      <div className='container mt-5 asossiate-chart'>
        <div className="container-fluid quality-title-1">Visitas por municipio</div>
        <div className="container">
          <div className="row">
            <div className="form-group col-12 col-md-6">
              <label htmlFor="new-business-name">Estado ó Municipio</label>
              <Input type='text' name='name' id='name'
                     onChange={this.handleChange} className='form-control'
                     placeholder='Buscar por estado ó municipio ...'/>
            </div>
            <div className="form-group col-12 col-md-3">
              <label htmlFor="visit-number-selector">Número de visitas</label>
              <select name="appointments" value={this.state.appointments} id="visit-number-selector"
                      className='form-control' onChange={this.handleChange}>
                <option value="" selected={'selected'}>Buscar por número de visitas</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
            <div className="form-group col-12 col-md-3 d-flex align-self-end">
              <Button color='primary' className='mr-2' onClick={()=>this.fetch(this.state.name, this.state.appointments)}>Buscar</Button>
              <Button color='Secondary' onClick={()=>this.fetch('','')}>Limpiar</Button>
            </div>
          </div>
        </div>
        <div style={{
          top: '0vh',
          left: '0%',
          width: '100%',
          height: '80vh',
          overflowY: 'auto',
        }}>
          <BarChart
            layout="vertical"
            width={1080}
            height={200+this.state.graphHeight}
            data={this.state.data}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3"/>
            <ReferenceLine x={1}/>
            <ReferenceLine x={2}/>
            <ReferenceLine x={3}/>
            <ReferenceLine x={4}/>
            <ReferenceLine x={5}/>
            <XAxis type="number" domain={[0, 5]} interval={0}/>
            <YAxis dataKey="name" type="category" width={200} interval={0}/>
            <Tooltip/>
            <Legend/>
            <Bar dataKey="visitas" barSize={20} fill="#F92424"/>
          </BarChart>
        </div>
      </div>
    );
  }

}

export default VisitsNewBusiness;



// WEBPACK FOOTER //
// ./src/charts/visitsNewBusiness.js